module.exports = __webpack_public_path__ + "770ff5e5233dc59f86d77c0f2e865a93.png";